import moment from 'moment'
import { IShipmentStopTypes } from 'types/graphqlTypes'
import { TStopSchema } from '../schema/ShipmentSchema/StopSchema'

/**
 * Returns an array of stops with a given stopType sorted by startAtDate
 *
 * @param {TStopSchema[]} stops Array of stops
 * @param {IShipmentStopTypes} stopType Type of stops to filter out and sort
 * @returns TStopSchema[]
 */
const getSortedStops = (stops: TStopSchema[], stopType: IShipmentStopTypes): TStopSchema[] => {
  const stopTypeStops = stops.filter(stop => stop.stopType === stopType)
  return stopTypeStops.sort((a, b) => {
    const aStartAtDate = moment(a.startAtDate)
    const bStartAtDate = moment(b.startAtDate)
    return bStartAtDate.isBefore(aStartAtDate) ? 1 : -1
  })
}

/**
 * Returns true if the stop is within the first pickup and last delivery dates
 *
 * @param {TStopSchema[]} shipmentStops All stops in a shipment
 * @param {TStopSchema} stop The stop that is being tested
 * @returns boolean
 */
export const isStopTimeValid = (shipmentStops: TStopSchema[], stop: TStopSchema): boolean => {
  const stopStartAtDate = moment(stop.startAtDate)

  // If the stop is a pickup - verify it is before the last delivery date
  if (stop.stopType === IShipmentStopTypes.pickup) {
    const deliveries = getSortedStops(shipmentStops, IShipmentStopTypes.delivery)
    if (deliveries.length <= 0) {
      return false
    }
    const lastDelivery = deliveries[deliveries.length - 1]
    const lastDeliveryDate = moment(lastDelivery.startAtDate)
    return stopStartAtDate.isSameOrBefore(lastDeliveryDate)
  }

  // If the stop is a delivery - verify it is after the first pickup
  const pickups = getSortedStops(shipmentStops, IShipmentStopTypes.pickup)
  if (pickups.length <= 0) {
    return false
  }
  const firstPickup = pickups[0]
  const firstPickupDate = moment(firstPickup.startAtDate)
  return stopStartAtDate.isSameOrAfter(firstPickupDate)
}
